import {
  useCallback,
  useRef,
  DependencyList,
  useEffect,
} from 'react';

export function useDebouncedCallback<
  T extends (...args: any[]) => any,
>(callback: T, deps: DependencyList, milliseconds?: number): T {
  const memoizedCallback = useCallback(callback, deps);

  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  function cleanup() {
    if (timeout.current !== null) {
      clearTimeout(timeout.current);
    }
  }

  const debouncedCallback = useCallback(
    (e: any) => {
      cleanup();

      timeout.current = setTimeout(() => {
        memoizedCallback(e);
      }, milliseconds);
    },
    [milliseconds, deps],
  );

  useEffect(() => {
    // clear any pending timers on unmount
    return () => {
      cleanup();
    };
  }, []);

  return debouncedCallback as T;
}
